<template>
  <div id="software">
     <div class="text">
        <p>一、项目概况</p>
        <p>
          区域传染病监测预警与应急指挥信息平台建设遵循统一设计、统一标准、统一技术架构、统一业务规范，支持横向纵向业务协同、信息共享。系统应用建设基于“平战结合”的设计思路，分为“平时应用”与“战时应用”两部分。
          其中“平时应用”包括应急准备、动态监测分析与预警管理、移动端应用和基础支撑；“战时”应用包括应急决策处置、调度指挥管理和疫情防控综合监管。依托数据中台技术实现数据汇聚、治理和建模，为前台应用及业务中台提供数据资源服务和数据ETL、数据分类、数据交换、智能分析工具等支撑服务。
        </p>
        <p>二、项目建设的必要性</p>
        <div class="flex">
          <img
            src="@/assets/images/20250724/ruanjian/yingji.svg"
            style="width: 100%;"
            alt=""
          />
        </div>
        <p>1、打破信息壁垒，增进业务协作，提高服务效率​：业务系统独立建设是阻碍各业务系统良好协作的主要问题，探索业务协同是提升业务效能的重要方向。基层信息化建设中目前遇到的主要问题是 “条块冲突”，本方案将构建以 “大融合、一体化” 为目标，结合区域传染病监测预警与应急指挥应用特点，秉承业务协作、提升效能的理念，并依托微服务为核心技术，打造创新业务融合的新一代传染病监测预警与应急指挥系统，促使传染病防控相关条线通过业务融合服务进行充分共享、联动和协作。
        </p>
        <p>2、数据资源中心为智能化服务创新提供支撑​：本方案建立的数据资源中心，可汇聚大量真实客观的传染病相关生产数据和业务数据，通过数据分析技术，建设传染病防控体系，进行传染病专项管理、预警预测、传播风险因素等指标分析，推动综合监管指标展示与分析应用建设，并逐步构建动态、科学的监测评估模型，从而推动数据资源中心在行业监管方面的应用，包括综合管理监管、传染病防控监管等，助力持续打磨传染病监测预警与应急指挥能力。</p>
        <p>3、区域统筹合作模式，达成多点监测触发​：加强区域统筹，加强乡镇卫生院和社区卫生服务中心传染病预防控制职责，夯实联防联控的基层基础，打通疾控、医疗、实验室等信息，实现医疗卫生机构、疾控机构疫情相关核心信息快速报送；以重大传染病哨点医院为重点，强化信息整合共享，逐步实现疫情信息自动推送，完善传染病监测体系；运用大数据支撑重点人群排查，突出疫情防控重点，提升精准防控能力；基于监测预警数据的研判分析、仿真建模、预测分析，建设跨部门多元融合数据平台和高效协同、上下联动的统一指挥平台，快速提升数据采集能力，形成重大突发传染病事件的多点触发防控体系。</p>
        <p>4、安全防线、保障数据安全，强化重要时期安全保障技术支撑​:为全面落实《国家网络安全事件应急预案》和卫生医疗行业的网络安全工作要求，强化对区域内卫生医疗行业的重大网络安全事件的应急协调和联动机制，提高医疗卫生机构应对网络安全事件的发现和处置能力，及时预防和减少网络安全事件造成的损失和危害，可通过对接区域密码平台提升整网网络安全的能力，通过数据的分析和研判，借助运营分析提升业务数据安全能力，助力网络安全应急响应工作有效开展。同时，在国家重要活动、会议期间，各级卫生健康委员会可协同区域内医疗机构相关单位加强网络安全监控和分析研判，在此期间可开展专项信息通报预警工作，建立 24 小时应急联络渠道，及时预警可能造成重大影响的风险和隐患，有效提高区域内医疗卫生行业重要时期业务安全的保障工作水平，支撑重要时期业务平稳运行。</p>
        <p>5、集中部署模式，实现统一管理与维护​：本方案采用集中部署模式，面向区域内全部医疗卫生机构，提供统一的传染病应急服务，实现区域内医疗卫生数据的有效落地，同时便于系统管理维护与升级，有助于缓解医疗卫生机构信息化持续运维能力不足的问题，统一管理和运维并能更高效地支撑平台可持续发展。相比较传统 IT 架构，这种架构在平台开发、实施和运维上都大大提升了效率并降低了成本，系统更加高效、可靠。</p>
        <p>三、建设内容</p>
        <p>1、数据资源中心（数据采集、数据治理、数据存储和数据中台的采购）；2、应用系统建设（基础支撑、应急准备、动态监测分析与预警管理、应急决策处置、调度指挥管理、调度指挥管理、移动单兵应用、移动端应用）3、应急通信系统；4、其他内容</p>
      </div>
  </div>
</template>
<script>
export default {
  name: "software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text{
  line-height: 24px;
  font-weight: 500;
    color: #666;
    margin-top: 30px;
    margin-right: 20px;
   text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution6.vue